import axios from "./axios";

export const tasksApi = {
  getTasks: async (params = {}) => axios.get("/tasks", { params }),

  // Lightweight counts for the dashboard header (avoids loading every open task).
  getTaskSummary: async (params = {}) => axios.get("/tasks/summary", { params }),

  getTask: async (id) => axios.get(`/tasks/${id}`),

  createTask: async (data) =>
    axios.post("/tasks", {
      task: data,
    }),

  updateTask: async (id, data) =>
    axios.put(`/tasks/${id}`, {
      task: data,
    }),

  deleteTask: async (id) => axios.delete(`/tasks/${id}`),

  toggleFinished: async (id, body = {}) => axios.post(`/tasks/${id}/toggle_finished`, body),

  getSettings: async () => axios.get("/tasks/settings"),

  updateSettings: async (payload) => axios.put("/tasks/settings", payload),

  spawnTemplate: async (templateId) =>
    axios.post(`/tasks/settings/templates/${templateId}/spawn`),

  // Project-scoped tasks (project "Oppgaver" tab). Tasks are ordinary task rows with project_id set.
  getProjectTasks: async (projectId, params = {}) =>
    axios.get(`/projects/${projectId}/tasks`, { params }),

  createProjectTask: async (projectId, data) =>
    axios.post(`/projects/${projectId}/tasks`, { task: data }),

  applyProjectTaskTemplateSet: async (projectId, templateSetId) =>
    axios.post(`/projects/${projectId}/tasks/apply_template_set`, {
      template_set_id: templateSetId,
    }),

  bulkUpdateProjectTasks: async (projectId, payload) =>
    axios.post(`/projects/${projectId}/tasks/bulk_update`, payload),
};

// Company-level admin CRUD for reusable project task template sets.
// Route path is `project-task-template-sets` (see config/routes.rb).
export const projectTaskTemplateSetsApi = {
  list: async (params = {}) =>
    axios.get("/project-task-template-sets", { params }),

  get: async (id) => axios.get(`/project-task-template-sets/${id}`),

  create: async (templateSet) =>
    axios.post("/project-task-template-sets", { template_set: templateSet }),

  update: async (id, templateSet) =>
    axios.put(`/project-task-template-sets/${id}`, { template_set: templateSet }),

  remove: async (id) => axios.delete(`/project-task-template-sets/${id}`),
};
